import { useIsMounted } from '@simplywallst/ui-core';
import { FairValueHistogramChart } from '@/pages/Narrative/components/FairValueHistogram/components/FairValueHistogramChart';
import type { FairValueHistogramCompanyFragment } from '@/pages/Narrative/components/FairValueHistogram/fairValueHistogramFragment';

const BARS = [10, 20, 50, 60, 100, 90, 20, 70, 60, 30];

type Props = {
  height?: number;
};

const FairValueHistogramSkeleton = ({ height = 100 }: Props) => {
  const chartHeight = height - 32;
  return (
    <div className="grid gap-x1">
      <div className="bones h-x3" />
      <div
        className="grid grid-cols-[repeat(10,1fr)] items-end gap-x1"
        style={{ height: chartHeight }}
      >
        {BARS.map((barHeight, index) => (
          <div
            key={index}
            className="bones"
            style={{ height: `${barHeight}%` }}
          />
        ))}
      </div>
      <div className="bones h-x4" />
    </div>
  );
};

export const FairValueHistogram = ({
  company,
  height = 270,
}: {
  company: FairValueHistogramCompanyFragment;
  height?: number;
}) => {
  const { primaryCount } = company.valuationHistogram ?? {};

  const isMounted = useIsMounted();

  if (!isMounted) return <FairValueHistogramSkeleton height={height} />;

  return (
    <div className="grid gap-x2">
      <p className="m-0 text-sm text-solid">
        Selected by {primaryCount} investors
      </p>
      {company.valuationHistogram && (
        <FairValueHistogramChart company={company} height={height} />
      )}
    </div>
  );
};
